<div class="cart-overlay"
     [class.open]="cart.isOpen()"
     (click)="cart.toggleCart()">
</div>

<div class="cart-sidebar" [class.open]="cart.isOpen()">

  <div class="cart-header">
    <span class="cart-title">Tu Carrito ({{ cart.totalItems() }})</span>
    <button class="close-btn" (click)="cart.toggleCart()">×</button>
  </div>

  <div class="cart-items">

    <div *ngIf="cart.cartItems().length === 0" class="empty-state">
      <p>Tu carrito está vacío</p>
      <button class="shop-now-btn" (click)="cart.toggleCart()">Empezar a comprar</button>
    </div>

    <div *ngFor="let item of cart.cartItems()" class="cart-item">

      <div class="item-img">
        <img [src]="item.productImage" [alt]="item.productName">
      </div>

      <div class="item-details">
        <div class="item-top">
          <span class="item-name">{{ item.productName }}</span>
          <span class="item-price">{{ (item.productPrice * item.quantity) | currency:'PEN':'symbol':'1.2-2'}}</span>
        </div>

        <div class="item-size">
          <span *ngIf="item.size">Talla: {{ item.size }}</span>
          <span *ngIf="item.color"> | {{ item.color }}</span>
        </div>

        <div class="item-controls">
          <div class="qty-control">
            <button (click)="cart.updateQuantity(item.idCartItem, item.size, item.quantity - 1)">-</button>
            <span>{{ item.quantity }}</span>
            <button (click)="cart.updateQuantity(item.idCartItem, item.size, item.quantity + 1)">+</button>
          </div>

          <button class="remove-btn" (click)="cart.removeFromCart(item.idCartItem)">Eliminar</button>
        </div>
      </div>
    </div>

  </div>

  <div class="cart-footer" *ngIf="cart.cartItems().length > 0">
    <div class="subtotal-row">
      <span>Subtotal</span>
      <span>{{ cart.subtotal() | currency:'PEN':'symbol':'1.2-2' }}</span>
    </div>
    <p class="shipping-note">Envío calculado al finalizar.</p>
    <button class="checkout-btn" (click)="checkout()">PROCESAR COMPRA</button>
  </div>
</div>
